import { useQuizPlayersScoreMutate } from '@mentimeter/core-hooks';
import { usePresentationSlideDeck } from '@mentimeter/presentation-data-hooks/slide-deck';
import { mergeMarkedAnswer } from '@mentimeter/quiz';
import { useSubscribeRealtimeReaction } from '@mentimeter/reactions-realtime';
import {
  Channels,
  SeriesPrivateEvents,
  useSubscribe,
} from '@mentimeter/realtime';

export const usePresentationSlideDeckSubscription = (
  slideDeckPublicKey: string,
  legacyQuestionId: string,
  shouldSubscribe = true,
) => {
  const { series: nullishSeries } = usePresentationSlideDeck(
    slideDeckPublicKey,
    {
      swrConfig: { suspense: true },
    },
  );
  const series = nullishSeries!;
  const mutateQuizPlayersScore = useQuizPlayersScoreMutate(legacyQuestionId);

  useSubscribeRealtimeReaction(series.vote_key, shouldSubscribe);

  useSubscribe(
    { channel: Channels.SERIES_PRIVATE, value: series.id, shouldSubscribe },
    SeriesPrivateEvents.QUIZ_MARKED_ANSWER,
    ({ data }) => {
      mutateQuizPlayersScore((players) => {
        if (!players || !data.payload) return players;
        return mergeMarkedAnswer(data.payload, players);
      });
    },
  );
};
